import { toast, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};

const NotificationService = {
    success: (message: string, options?: ToastOptions) => {
        toast.success(message, { ...defaultOptions, ...options });
    },
    error: (message: string, options?: ToastOptions) => {
        toast.error(message, { ...defaultOptions, ...options });
    },
    info: (message: string, options?: ToastOptions) => {
        toast.info(message, { ...defaultOptions, ...options });
    },
    warning: (message: string, options?: ToastOptions) => {
        toast.warn(message, { ...defaultOptions, ...options });
    },
    handleError: (error: any) => {
        console.log(error)
        if(error.response.data.problemDetails)
            toast.error(error.response.data.problemDetails.detail, { ...defaultOptions });
        else if(error.message)
            toast.error(error.message, { ...defaultOptions });
        else
            toast.error("Unknown Error", { ...defaultOptions });
    }
};

export default NotificationService;
